import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-page-two',
  templateUrl: './about-page-two.component.html',
  styleUrls: ['./about-page-two.component.scss']
})
export class AboutPageTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
